import { registerWebComponent } from '@sdx/b2o-alicia-chatbot-module';
import { useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../core/contexts/AuthContext';
import { useApp } from '../../core/contexts/AppContext';
import { useIsDesktop } from '../../core/hooks/useMediaQuery';
import { MOBILE_NAV_HEIGHT } from '../../core/constants/layout';

interface AliciaChatbotModuleProps {
  destroy?: boolean;
  hide?: boolean;
}

const AliciaChatbotModule = ({ destroy = false, hide = false }: AliciaChatbotModuleProps) => {
  const { i18n } = useTranslation();
  const { accessToken } = useAuth();
  const { setIsChatbotOpen, isChatbotOpen, isAliciaChatbotMenuOpen } = useApp();

  const moduleRef = useRef<HTMLElement>(null);
  const isDesktop = useIsDesktop();

  const handleChatbotToogle = useCallback(
    (event: Event): void => {
      const customEvent = event as CustomEvent;
      const { isOpen } = customEvent?.detail ?? {};

      setIsChatbotOpen(isOpen);
    },
    [setIsChatbotOpen],
  );

  useEffect(() => {
    registerWebComponent('b2o-alicia-chatbot-module');
  }, []);

  useEffect(() => {
    const element = moduleRef.current;

    if (element) {
      element.addEventListener('chatbottoggle', handleChatbotToogle);
    }

    return (): void => {
      if (element) {
        element.removeEventListener('chatbottoggle', handleChatbotToogle);
      }
    };
  }, [handleChatbotToogle]);

  return (
    <b2o-alicia-chatbot-module
      ref={moduleRef}
      access-token={accessToken ?? ''}
      env={String(import.meta.env.VITE_APP_ENVIRONMENT)}
      language={i18n.language}
      destroy={destroy}
      hide={(!isDesktop && !isAliciaChatbotMenuOpen) || hide}
      open={isChatbotOpen}
      auto-open-fullscreen={isAliciaChatbotMenuOpen}
      iframe-style={JSON.stringify({
        maxHeight: `calc(100vh - ${isDesktop ? '0px' : MOBILE_NAV_HEIGHT})`,
      })}
    />
  );
};

export default AliciaChatbotModule;
